import {store} from "@/store/store";

// регистрация в лк
function agreementAcceptedExtensionsArr(): string[] {
  return store.state.config.config["REGISTRATION_AVAILABLE_FORMATS"].split(',');
}
function agreementAcceptedExtensions(): string {
  return agreementAcceptedExtensionsArr().map(_ => '.' + _).join(',');
}
function agreementAcceptedFileSize(): number {
  return Math.round((store.state.config.config["REGISTRATION_AVAILABLE_BYTES"] / (1024 * 1024)));
}
function agreementAcceptedExtensionsHint(): string {
  return 'Доступны форматы: ' + store.state.config.config["REGISTRATION_AVAILABLE_FORMATS"] +
    ', максимальный размер ' + agreementAcceptedFileSize().toString() + 'МБ';
}

// помесячный план
function monthlyPlanAcceptedExtensionsArr(): string[] {
  return store.state.config.config["MONTHLY_PLAN_AVAILABLE_FORMATS"].split(',');
}
function monthlyPlanAcceptedExtensions(): string {
  return monthlyPlanAcceptedExtensionsArr().map(_ => '.' + _).join(',');
}
function monthlyPlanAcceptedFileSize(): number {
  return Math.round((store.state.config.config["MONTHLY_PLAN_AVAILABLE_BYTES"] / (1024 * 1024)));
}
function monthlyPlanAcceptedExtensionsHint(): string {
  return 'Доступны форматы: ' + store.state.config.config["MONTHLY_PLAN_AVAILABLE_FORMATS"] +
    ', максимальный размер ' + monthlyPlanAcceptedFileSize().toString() + 'МБ';
}

// обращения
function appealsAcceptedExtensionsArr(): string[] {
  return store.state.config.config["APPEALS_AVAILABLE_FORMATS"].split(',');
}
function appealsAcceptedExtensions(): string {
  return appealsAcceptedExtensionsArr().map(_ => '.' + _).join(',');
}
function appealsAcceptedFileSize(): number {
  return Math.round((store.state.config.config["APPEALS_AVAILABLE_BYTES"] / (1024 * 1024)));
}
function appealsAvailableCount(): number {
  return Math.round((store.state.config.config["APPEALS_AVAILABLE_COUNT"]));
}
function appealsAcceptedExtensionsHint(): string {
  return 'Доступны форматы: ' + store.state.config.config["APPEALS_AVAILABLE_FORMATS"] +
    ', максимальный размер ' + appealsAcceptedFileSize().toString() + 'МБ' +
    ' (не более ' + appealsAvailableCount() + ' файлов)';
}

function checkFiles(files: Array<File>, extensions: string[], fileSize: number): string[] {
  let result = [];
  (files || []).forEach(f => {
    if (!extensions.includes(f.name.split('.').pop())) {
      const error = "Некорректный формат";
      if (!result.includes(error)) {
        result.push(error);
      }
    } else if (Math.round(f.size / (1024 * 1024)) > fileSize) {
      const error = "Превышен максимальный размер файла";
      if (!result.includes(error)) {
        result.push(error);
      }
    }
  });
  return result;
}

export {
  agreementAcceptedExtensionsArr, agreementAcceptedExtensions, agreementAcceptedFileSize, agreementAcceptedExtensionsHint,
  monthlyPlanAcceptedExtensionsArr, monthlyPlanAcceptedExtensions, monthlyPlanAcceptedFileSize, monthlyPlanAcceptedExtensionsHint,
  appealsAcceptedExtensionsArr, appealsAcceptedExtensions, appealsAcceptedFileSize, appealsAvailableCount, appealsAcceptedExtensionsHint,
  checkFiles,
};
